import DotNetSplashLayoutLegacy from "../DotNetSplashLegacy/DotNetSplashLayoutLegacy";

const DotNetSplash2xLegacy = ({id, zoom}: {id: string; zoom: number}) => (
  <DotNetSplashLayoutLegacy id={id} zoom={zoom} scale={2} fallbackTransformId="DotNetSplash2x" />
);

export default DotNetSplash2xLegacy;
